/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Short_Notice_DescriptionInputs */



/**
* | output |
* | --- |
* | "The Guardrails feature is a rule-based filtering system for content moderation using regex pattern matching." |
*
* @param {Guardrails_Short_Notice_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_short_notice_description = /** @type {((inputs?: Guardrails_Short_Notice_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Short_Notice_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Guardrails-Funktion ist ein regelbasiertes Filtersystem zur Content-Filterung auf Basis von Regex-Pattern-Matching.")
	return /** @type {LocalizedString} */ ("The Guardrails feature is a rule-based filtering system for content moderation using regex pattern matching.")
});